// PhysioFix "PF" mark (vector, traced from the brand logo). The P follows the text color so it works in dark mode.
export function LogoMark({ size = 32, style }) {
  return (
    <svg viewBox="330 545 1050 730" width={size * 1.44} height={size} style={{ display: 'block', flexShrink: 0, ...style }} aria-label="PhysioFix">
      <polygon fill="currentColor" points="395,553 810,553 891,659 814,1012 629,1104 588,958 742,881 783,691 642,691 595,908 545,942 568,1028 516,1268 336,1268 471,652" />
      <polygon fill="#1891C8" points="842,553 1374,553 1329,757 1150,757 1164,691 1090,691 1059,837 1289,837 1101,975 1028,975 964,1268 784,1268 918,653" />
    </svg>
  );
}

export default function Logo({ size = 28, sub, color = 'var(--text)' }) {
  return (
    <div dir="ltr" className="flex items-center gap-8" style={{ color, direction: 'ltr' }}>
      <LogoMark size={size} />
      <div style={{ lineHeight: 1.05 }}>
        <div dir="ltr" style={{ fontFamily: 'var(--font-brand)', fontWeight: 800, fontSize: size * 0.68, letterSpacing: '-0.02em' }}>
          Physio<span style={{ color: 'var(--primary)' }}>Fix</span>
        </div>
        {sub && <div style={{ fontSize: Math.max(10, size * 0.36), color: 'var(--text3)', fontWeight: 500, marginTop: 2 }}>{sub}</div>}
      </div>
    </div>
  );
}
